import { AppState, Auth0Provider } from "@auth0/auth0-react";
import React, { PropsWithChildren } from "react";

import config from "../config";
import { useNavigate } from "react-router-dom";

type Auth0ProviderWithHistoryProps = PropsWithChildren<unknown>;
const Auth0ProviderWithHistory: React.FC<Auth0ProviderWithHistoryProps> = ({ children }) => {
    const navigate = useNavigate();
    const onRedirectCallback = (appState?: AppState) => {
        navigate(appState?.returnTo || window.location.pathname);
    };

    // Dev-only Auth0 workaround: persist tokens to localStorage so refresh survives re-renders on the
    // local dev server. import.meta.env.DEV is a build-time constant — true only under `vite dev` — so
    // Vite strips the localStorage branch entirely from every built artifact (dev/uat/prod).
    const isDevServer = import.meta.env.DEV;

    return (
        <Auth0Provider
            domain={config.auth0.domain}
            clientId={config.auth0.clientId}
            authorizationParams={{
                redirect_uri: window.location.origin,
                audience: config.auth0.audience
            }}
            onRedirectCallback={onRedirectCallback}
            useRefreshTokens={isDevServer}
            cacheLocation={isDevServer ? "localstorage" : "memory"}
        >
            {children}
        </Auth0Provider>
    );
};

export default Auth0ProviderWithHistory;
